export const URL_ADMIN = "admin"
export const URL_TEACHER = "teacher"
export const URL_STUDENT = "student"

export const WSFUNCTION = {
  CREATE_CATEGORY: 'core_course_create_categories',
  GET_CATEGORY: 'core_course_get_categories',
  UPDATE_CATEGORY: 'core_course_update_categories',
  DELETE_CATEGORY: 'core_course_delete_categories',

  CREATE_COURSE: 'core_course_create_courses',
  GET_COURSE: 'core_course_get_courses',
  UPDATE_COURSE: 'core_course_update_courses',
  DELETE_COURSE: 'core_course_delete_courses',

  CREATE_USER: 'core_user_create_users',
  GET_USER: 'core_user_get_users_by_field',
  UPDATE_USER: 'core_user_update_users',
  DELETE_USER: 'core_user_delete_users',
  ENROLED_LIST: 'core_enrol_get_enrolled_users',

  GET_CORE_CONTENT_LIST: 'core_course_get_contents',
  GET_ATTENDANCE_GET_SESSION_LIST: 'mod_attendance_get_session',
  GET_ATTENDANCE_SPECIFIC_USER_LIST:'mod_attendance_get_attendance_log',
  CREATE_ATTENDANCE_ADD_SESSION:'mod_attendance_add_session',

  ENROL_MANUAL_ENROL_USERS: 'enrol_manual_enrol_users',
  ENROL_MANUAL_UNENROL_USERS: 'enrol_manual_unenrol_users',
  GET_USER_DETAILS: 'core_user_get_users',
  GET_STUDENT_GRADE_DETAILS: 'gradereport_user_get_grade_items',
  MOD_ATTENDANCE_GET_SESSIONS:'mod_attendance_get_sessions',
  MOD_ENROL_GET_USERS_COURSES: 'core_enrol_get_users_courses',
  

};

export const ROLEID = {
  TEACHER: 3,
  STUDENT: 5
};
